import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const Vouchers: FC = () => {
  const tenantConfiguration = useTenantConfiguration();

  // navigate back to account details if tenant doesn't show vouchers
  if (!tenantConfiguration?.showAccountMenuVouchers) {
    return <Navigate to="/account/details" replace />;
  }

  return (
    <HistoryLayout bookingType="vouchers">
      <Outlet />
    </HistoryLayout>
  );
};

export default Vouchers;
